<template>
<div class="k-page-content">
    <div class="mg-title-header">
        <h1> <i class="el-icon-arrow-left"></i> 编辑素材</h1>
    </div>
    <div class="mg-table-wrapper" style="overflow: auto;">
        <el-form label-width="110px" label-position="left" :size="size" :model="editSource" ref="editSource" :rules="rules.editSource">
        <div class="extra-area">
            <div class="block-title">基本信息</div>
            <div class="block-form">
                <el-form-item label="素材名称" prop="name">
                    <el-input
                        type="text"
                        v-model="editSource.name"
                        maxlength="70"
                        show-word-limit
                        style="width:220px"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item label="素材专辑" prop="source_group_id">
                    <el-cascader v-model="editSource.source_group_id" :options="treeData" :props="cascaderProps2" clearable style="width:220px;" popper-class='sourceCas' :show-all-levels="false"></el-cascader>
                </el-form-item>
                <el-form-item label="创意人" prop="creativityIds">
                    <el-select
                    placeholder="请选择创意人" 
                    clearable
                    v-model="editSource.creativityIds" 
                    style="width:220px">
                        <el-option
                            v-for="item in userOptions"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="person_add">
                        <span class="no-found">找不到人员？</span>
                        <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                        <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
                    </div>
                </el-form-item>
                <el-form-item label="设计师" prop="designIds">
                    <el-select
                    clearable
                    placeholder="请选择设计师" v-model="editSource.designIds" style="width:220px">
                        <el-option
                            v-for="item in userOptions"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="person_add">
                        <span class="no-found">找不到人员？</span>
                        <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                        <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
                    </div>
                </el-form-item>
                <el-form-item label="素材备注(选填)" prop="remark">
                    <el-input
                    v-model="editSource.remark"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 3}"
                    placeholder="请输入备注"
                    style="width:340px">
                    </el-input>
                </el-form-item>
            </div>
        </div>
        <div class="extra-area">
            <div class="block-title">附加信息(选填) <i class="el-icon-arrow-down" :class="active" @click="attachOpen"></i></div>
            <div class="block-form" v-show="isShow">
                <el-form-item label="拍摄人员" prop="shootIds">
                    <el-select
                    clearable
                    multiple
                    placeholder="请选择拍摄人员" v-model="editSource.shootIds" style="width:220px">
                        <el-option
                            v-for="item in userOptions"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="person_add">
                        <span class="no-found">找不到人员？</span>
                        <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                        <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
                    </div>
                </el-form-item>
                <el-form-item label="参演人员" prop="actorIds">
                    <el-select
                    clearable
                    multiple
                    placeholder="请选择参演人员" v-model="editSource.actorIds" style="width:220px">
                        <el-option
                            v-for="item in userOptions"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="person_add">
                        <span class="no-found">找不到人员？</span>
                        <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                        <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
                    </div>
                </el-form-item>
                <el-form-item label="配音人员" prop="dubIds">
                    <el-select
                    clearable
                    multiple
                    placeholder="请选择配音人员" v-model="editSource.dubIds" style="width:220px">
                        <el-option
                            v-for="item in userOptions"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="person_add">
                        <span class="no-found">找不到人员？</span>
                        <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                        <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
                    </div>
                </el-form-item>
                <el-form-item label="录屏人员" prop="screenRecordingIds">
                    <el-select
                    clearable
                    multiple
                    placeholder="请选择录屏人员" v-model="editSource.screenRecordingIds" style="width:220px">
                        <el-option
                            v-for="item in userOptions"
                            :key="item.id"
                            :label="item.nickname"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="person_add">
                        <span class="no-found">找不到人员？</span>
                        <a class="add_person" v-if="info.views.isManager == 1" @click="addUserOpen">添加人员</a>
                        <a class="add_person" v-if="info.views.isManager != 1" @click="addUserTips">添加人员</a>
                    </div>
                </el-form-item>
            </div>
        </div>
        <div class="extra-area" style="padding-bottom:24px;">
            <div class="block-title">
                素材
            </div>
            <div class="block-form">
                <div class="upload_area">
                    <div class="show_area">
                        <img :src="editSource.top_img" v-if="editSource.type == 'image'">
                        <video v-if="editSource.type == 'video'" :src="editSource.file" :poster="editSource.top_img" controls="controls" preload="none" class="vertical"></video>
                    </div>
                    <div class="replace-mask">
                        <el-button type="primary" :size="size" class="btn_replace" @click="replaceSource">替换素材</el-button>
                    </div>
                    <el-upload
                        style="display:none;"
                        class="upload-source"
                        ref="fileRefs"
                        :action="diaLog.uploadUrl"
                        :show-file-list="false"
                        :on-success="uploadSuccess"
                        :before-upload="detectMaterial">
                        <el-button :size="size" type="primary">点击上传</el-button>
                    </el-upload>
                </div>
            </div>
        </div>
        <div class="extra-area" style="padding:24px 0 24px 45px;">
            <el-button type="primary" :size="size" style="width:120px;" @click="submitSource('editSource')">完成</el-button>
        </div>
    </el-form>
    </div>
</div>
</template>
<script>
export default {
  props: ['info'],
  data() {
   	return {
          limit:'1',
          sourceId:'',
          treeData:[],
          cascaderProps2:{
              checkStrictly:true,
              value: 'id',
              label: 'name',
              children: 'child' 
          },
          value2: [],
          size:"small",
          sizemini:'mini',
          //图片上传后预览
          diaLog: {
              type: 'image',
              uploadUrl: 'api/assets/upload',
              dialogImageUrl: '',
              previewVisible: false
          },
          editSource: {
              name:'',
              creativityIds:'',
              designIds:'',
              shootIds:[],
              actorIds:[],
              dubIds:[],
              screenRecordingIds:[],
              source_group_id:[],
              remark:"",
              filelist:[],
          },
          editSourceForm:{
              name:'',
              creativityIds:'',
              designIds:'',
              shootIds:[],
              actorIds:[],
              dubIds:[],
              screenRecordingIds:[],
              source_group_id:[],
              remark:"",
              filelist:[],
              oldFileId:''
          },
          userOptions:[],
          rules: {
              editSource: {
                  'name': [
                      {required: true, message: '请填写素材名称', trigger: ['change', 'blur']},
                      {max: 70, message: '名称长度不能超过 70 个汉字或字符', trigger: ['change', 'blur']}
                  ],
                  'source_group_id': [
                      {type: 'array', required: true, message: '请选择素材目录', trigger:  'change' }
                  ],
                  'creativityIds': [
                      { required: true, message: '请选择创意人', trigger: 'change' }
                  ],
                  'designIds': [
                      { required: true, message: '请选择设计师', trigger: 'change' }
                  ]
              },
          },
          userdialogVisible: false,
          loading:false,
          isShow: false,
          active:'',
          replaceCheck:false,
   	}
  },
  watch: {
      
  },
  computed: {
  
  },
  methods: {
      //上传成功方法
      uploadSuccess:function(response, file, fileList){
          if(response.code == 0){
              this.editSource.top_img = response.data.image_url;
              this.editSource.filelist = [];
              this.editSource.filelist.push({'fileId':response.data.fileId});
              this.replaceCheck = true;
          }else{
              var index = fileList.indexOf(file);
              if (index !== -1) {
                  fileList.splice(index, 1)
              }
              this.$notify({
                  title: '警 告',
                  message: response.message,
                  type: 'warning'
              });
              return false;
          }
      },
      // 上传之前的检测
      detectMaterial:function(file) {
          var arr = file.type.split('/');
          if (this.editSource.source_group_id.length < 1 && this.editSource.creativityIds.length < 1 && this.editSource.designIds.length < 1) {
              this.$notify({
                  title: '警 告',
                  message: '为确保素材完成上传即保存至素材库，请先将素材相关信息补充完整。',
                  type: 'warning'
              });
              return false;
          }else if(arr[0] == 'video' && file.size / 1024 / 1024 > 200){
              this.$notify({
                  title: '警 告',
                  message: '您上传的视频素材超过200M的限制',
                  type: 'warning'
              });
              return false;
          }else if(arr[0] == 'image' && file.size / 1024 / 1024 > 1.5) {
              this.$notify({
                  title: '警 告',
                  message: '您上传的图片素材超过3M的限制',
                  type: 'warning'
              });
              return false;
          }
      },
      //获取素材目录
      getTreeData(){
		  this.loading = true;
		  this.$api.assets.getGroupTree().then(res=>{
			  if (res.code === 0) {
			      this.treeData = res.data.res;
			  } else {
			      var message = '查询应用列表信息失败！';
			      if (res.message) {
			          message = res.message;
			      }
			      this.$message({
			          showClose: true,
			          message: message,
			          type: 'error'
			      });
			  }
			  this.loading = false;
		  })
      },
      //获取附加人员
      handleUser:function(){
		  this.$api.assets.getSub().then(res=>{
			  this.userOptions = res.data;
		  })
      },
      //获取素材信息
      handleInfo: function () {
		  this.loading = true;
		  this.$api.assets.getSourceDetail({
              sourceId:this.sourceId
          }).then(res=>{
			  if (res.code == 0) {
			      this.editSource = res.data;
			      this.editSource.source_group_id = res.data.path;
			      this.editSource.oldFileId = res.data.source_file_id;
			      this.editSource.sourceId = this.sourceId;
			  } else {
			      var message = '素材信息获取失败！';
			      if (res.message) {
			          message = res.message;
			      }
			      this.$message({
			          showClose: true,
			          message: message,
			          type: 'error'
			      });
			  }
			  this.loading = false;
		  })
          
      },
      //添加人员
      addUserOpen:function(){
		  this.$router.replace('/user')
      },
      //添加人员-联系主账户
      addUserTips:function(){
          this.userdialogVisible = true;
      },
      //提交表单
      submitSource:function(formName){
          this.loading = true;
          this.$refs[formName].validate(function (valid) {
              if (!valid) {
                  this.loading = false;
                  return false;
              }
              this.editSourceForm.name = this.editSource.name;
              this.editSourceForm.creativityIds = this.editSource.creativityIds;
              this.editSourceForm.designIds = this.editSource.designIds;
              this.editSourceForm.shootIds = this.editSource.shootIds;
              this.editSourceForm.actorIds = this.editSource.actorIds;
              this.editSourceForm.dubIds = this.editSource.dubIds;
              this.editSourceForm.screenRecordingIds = this.editSource.screenRecordingIds;
              this.editSourceForm.source_group_id = this.editSource.source_group_id;
              this.editSourceForm.remark = this.editSource.remark;
              this.editSourceForm.filelist = this.editSource.filelist;
              if(this.replaceCheck){
                  this.editSourceForm.oldFileId = this.editSource.oldFileId;
              }else{
                  this.editSourceForm.oldFileId = '';
              }
              this.editSourceForm.sourceId = this.editSource.sourceId;
              this.$api.assets.getSourceDetail(this.editSourceForm).then(res=>{
				  if (res.code == '0') {
				      this.$message({
				          message: '素材编辑成功！',
				          type: 'success'
				      });
				      this.loading = false;
				  	  this.$router.replace('/source')
				  } else {
				      var message = '服务器数据异常！';
				      if (res.body.message) {
				          message = res.body.message;
				      }
				      this.$notify({
				          title: '警 告',
				          message: message,
				          type: 'warning'
				      });
				      this.loading = false;
				  }
			  })
          }.bind(this));
      },
      submitTips() {
          this.$message({
          showClose: true,
          message: '请完善相关信息',
          type: 'error'
          });
      },
      //展开附加信息
      attachOpen:function(){
          this.isShow = !this.isShow;
          if(this.isShow){
              this.active='is-active';
          }else{
              this.active='';
          }
      },
      //替换素材
      replaceSource:function(){
          this.$confirm('替换素材后，旧素材的历史数据将被全部清空，新素材只有在用于广告投放后才会产生素材数据。确认替换现在的素材信息吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
          }).then(() => {
              this.$refs['fileRefs'].$refs['upload-inner'].handleClick();
          }).catch(() => {
              this.$message({
                  type: 'info',
                  message: '已取消'
              });          
          });
      }
  
  },
  mounted: function () {
      var sourceIdQuery = this.$viewUrl('sourceId');
      if(sourceIdQuery){
          this.sourceId = sourceIdQuery;
      }
      this.handleUser();
      this.getTreeData();
      this.handleInfo();
      this.$nextTick(() => {
          this.$refs["editSource"].clearValidate()
      })
  },
  beforeRouteUpdate: function (to, from, next) {
      this.getTreeData();
      next();
  }
}
</script>